import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { GeoJSON } from 'ol/format';
import Feature from 'ol/Feature';
import { Circle, Fill, Stroke, Style } from 'ol/style';
export default {
  methods: {
    addFeatureHoverLayer() {
      const newLayer = new VectorLayer({
        id: 'featureHoverLayer',
        isSpecial: true,
        zIndex: 999,
        source: new VectorSource({
          features: [],
        }),
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 0, 0, 0.6)',
          }),
          stroke: new Stroke({
            color: 'rgba(255, 0, 0, 1)',
            width: 3,
          }),
          image: new Circle({
            radius: 5,
            stroke: new Stroke({
              color: 'rgba(255, 0, 0, 1)',
            }),
            fill: new Fill({
              color: 'rgba(255, 0, 0, 0.6)',
            }),
          }),
        }),
      });
      this.map.addLayer(newLayer);
    },
    toggleFeatureHover(relation, value) {
      let layer = this.getLayerById('featureHoverLayer');
      if (!value && layer) {
        this.clearLayer('featureHoverLayer');
        return;
      }
      if (!layer) {
        this.addFeatureHoverLayer();
        layer = this.getLayerById('featureHoverLayer');
      } else {
        this.clearLayer('featureHoverLayer');
      }
      const olGeometry = new GeoJSON().readGeometry(relation.geometry, {
        dataProjection: this.$_config.defaultEpsg,
        featureProjection: this.$_config.defaultEpsg,
      });
      const feature = new Feature({ geometry: olGeometry });
      layer.getSource().addFeature(feature);
    },
  },
  mounted() {
    this.$root.$off('toggleFeatureHover');
    this.$root.$on('toggleFeatureHover', this.toggleFeatureHover);
  },
};
